//@import dependencies
import React, { Fragment } from 'react'
//@end

//@import components
//@end

import '../auth.scss'

// @ADD Component types
interface IAuthComponent {
  children?: any
  background: any
  error?: any
  company?: any
}

const AuthComponent: React.FC<IAuthComponent> = ({
  children,
  background,
  error,
  company
}) => {
  const defaultLogo = require('app_assets/images/logos/logo.png')

  return(
    <Fragment>
      <div className="login-component auth-component--layout" style={{backgroundImage: `url('${background}')`}}>
        {error && (
          <div className='alert alert-danger mb-3' role='alert'>
            {error}
          </div>
        )}
        <div className={`login-header ${(company) ? 'company-selected' : ''}`}>
          <div className="default-logo">
            <img src={defaultLogo} alt=""/>
          </div>
        </div>
        {children}
      </div>
    </Fragment>
  )
}

export default AuthComponent
